module.exports = __webpack_public_path__ + "static/media/Bitmap.e85c625f.png";